import * as React from "react";
const SvgFiRrLoan = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-loan_svg__a)">
      <path
        fill="#062147"
        d="M23.018 8.785a2.97 2.97 0 0 0-2.169-.782 2.98 2.98 0 0 0-2.085.981l-3.217 3.534a3.15 3.15 0 0 0-1.945-1.425A3.43 3.43 0 0 0 14 9.511c0-2.517-1.763-5.472-4.115-6.569.337-.352.666-.743.93-1.163.488-.772-.048-1.78-.962-1.78H6.145c-.914 0-1.449 1.008-.962 1.78.265.42.593.81.93 1.163-2.352 1.096-4.115 4.052-4.115 6.569 0 .654.193 1.26.508 1.783a4 4 0 0 0-2.508 3.705v5c0 2.206 1.794 4 4 4h4.965c2.85 0 5.57-1.22 7.467-3.348l6.804-7.637a3.02 3.02 0 0 0-.218-4.23zM8 4.5c1.821.049 4 2.738 4 5.012 0 .821-.673 1.488-1.5 1.488h-5C4.673 11 4 10.333 4 9.512 4 7.238 6.18 4.549 8 4.5m13.742 7.184-6.805 7.638A8 8 0 0 1 8.964 22H4c-1.103 0-2-.897-2-2v-5c0-1.103.897-2 2-2h8.857c.63 0 1.143.512 1.143 1.142a1.15 1.15 0 0 1-.98 1.131l-5.16.737a1 1 0 1 0 .282 1.979l5.161-.737a3.16 3.16 0 0 0 2.514-2.058l4.427-4.865c.181-.2.43-.316.699-.329.271-.007.528.082.728.262.407.372.44 1.009.072 1.421z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-loan_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLoan;
